/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { NavigationListItem } from './components';

const NavigationList = ({
  pages,
  depth = 0,
  isMenuCollapse,
  setActiveKey,
  activeKey,
  onSelect,
}) => {
  const location = useLocation();

  return (
    <>
      {pages.map((page) => {
        const hasChildren = Array.isArray(page.children) && page.children.length > 0;
        return (
          <NavigationListItem
            key={page.id || page.title}
            title={page.title}
            href={page.href}
            depth={depth}
            pageid={page.id}
            menuIcon={page.menu_icon}
            isMenuCollapse={isMenuCollapse}
            setActiveKey={setActiveKey}
            open={location.pathname.includes(page.href)}
            activeKey={activeKey}
            onSelect={onSelect}
          >
            {hasChildren && (
              <NavigationList
                pages={page.children}
                depth={depth + 1}
                isMenuCollapse={isMenuCollapse}
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                onSelect={onSelect}
              />
            )}
          </NavigationListItem>
        );
      })}
    </>
  );
};

NavigationList.propTypes = {
  pages: PropTypes.array.isRequired,
  depth: PropTypes.number,
  isMenuCollapse: PropTypes.bool,
  setActiveKey: PropTypes.func,
  activeKey: PropTypes.array,
  onSelect: PropTypes.func,
};

const Navigation = (props) => {
  const {
    pages,
    component: Component,
    isMenuCollapse,
    setActiveKey,
    activeKey,
    onSelect,
    ...rest
  } = props;
  return (
    <Component {...rest}>
      <NavigationList
        pages={pages}
        depth={0}
        isMenuCollapse={isMenuCollapse}
        setActiveKey={setActiveKey}
        activeKey={activeKey}
        onSelect={onSelect}
      />
    </Component>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string,
  activeKey: PropTypes.array,
  onSelect: PropTypes.func,
};

Navigation.defaultProps = {
  component: 'div',
};

export default Navigation;
